import actions from "../actionTypes";

export const sendEmail = payload => ({
  type: actions.CANDIDATE_EMAIL,
  payload
});

export const listEmail = payload => ({
  type: actions.CANDIDATE_EMAIL_LIST,
  payload
});

export const listEmails = payload => ({
  type: actions.EMAIL_LIST,
  payload
});

export const clearListEmails = () => ({
  type: actions.EMAIL_LIST_CLEAR
});

export const clearListEmail = () => ({
  type: actions.CANDIDATE_EMAIL_LIST_CLEAR
});

export const clearSendEmail = () => ({
  type: actions.CANDIDATE_EMAIL_CLEAR
});

export const getCandidateListData = data => ({
  type: actions.CANDIDATE_LISTING,
  data
});

export const getCandidateDuplicates = data => ({
  type: actions.CANDIDATE_DUPLICATES,
  data
});

export const deleteCandidates = data => ({
  type: actions.CANDIDATE_DELETE,
  data
});

export const deletePerson = data => ({
  type: actions.PERSON_DELETE,
  data
});

export const attachNewCandidates = data => ({
  type: actions.ATTACH_NEW_CANDIDATE,
  data
});

export const mergePerson = data => ({
  type: actions.PERSON_DELETE_MERGE,
  data
});

export const getGlobalSearch = data => ({
  type: actions.GLOBAL_SEARCH,
  data
});

export const mergeAndDeleteCandidates = data => ({
  type: actions.CANDIDATE_MERGE_DELETE,
  data
});

export const addAvailability = data => ({
  type: actions.ADD_AVAILABILITY,
  data
});

export const addTimeOff = data => ({
  type: actions.ADD_TIMEOFF,
  data
});

export const removeAvailability = data => ({
  type: actions.REMOVE_AVAILABILITY,
  data
});

export const deleteTimeOff = data => ({
  type: actions.DELETE_TIMEOFF,
  data
});

export const bookingOperation = data => ({
  type: actions.CALENDAR_BOOKING_OPERATION,
  data
});

export const getRepeatBookingsList = data => ({
  type: actions.GET_REPEAT_BOOKINGS_LIST,
  data
});

export const getBookingStartingRate = data => ({
  type: actions.GET_BOOKING_STARTING_RATE,
  data
});

export const calculateBookingPay = data => ({
  type: actions.CALCULATE_BOOKING_PAY,
  data
});

export const clearCalculateBookingPay = () => ({
  type: actions.CALCULATE_BOOKING_PAY_CLEAR
});

export const getClientPayRates = data => ({
  type: actions.GET_CLIENT_PAY_RATES,
  data
});

export const updateBookingPayRates = data => ({
  type: actions.UPDATE_BOOKING_PAY_RATES,
  data
});

export const updateBookingDetailsData = data => ({
  type: actions.UPDATE_BOOKING_DETAILS_DATA,
  data
});

export const clearBookingDetailsData = data => ({
  type: actions.UPDATE_BOOKING_DETAILS_DATA_CLEAR,
  data
});

export const confirmAllBookingOperation = data => ({
  type: actions.CONFIRM_ALL_BOOKING_OPERATION,
  data
});

export const confirmTimeOff = data => ({
  type: actions.CONFIRM_TIME_OFF,
  data
});

export const addCandidateImport = data => ({
  type: actions.ADD_CANDIDATE_IMPORT,
  data
});

export const clearCandidateImport = () => ({
  type: actions.ADD_CANDIDATE_IMPORT_CLEAR
});

export const hoursWorkedImport = data => ({
  type: actions.HOURS_WORKED_IMPORT,
  data
});

export const updatePersonNote = data => ({
  type: actions.UPDATE_PERSON_NOTE,
  data
});

export const clearPersonNoteData = () => ({ type: actions.UPDATE_PERSON_NOTE_CLEAR });
export const hoursWorkedImportClear = () => ({ type: actions.HOURS_WORKED_IMPORT_CLEAR });
export const clearAddTimeoff = () => ({ type: actions.ADD_TIMEOFF_CLEAR });
export const clearBookingOperation = () => ({ type: actions.CALENDAR_BOOKING_OPERATION_CLEAR });
export const clearConfirmAllBooking = () => ({ type: actions.CONFIRM_ALL_BOOKING_OPERATION_CLEAR });
export const clearGlobalSearch = () => ({ type: actions.GLOBAL_SEARCH_CLEAR });
export const clearAttachCandidate = () => ({ type: actions.ATTACH_NEW_CANDIDATE_CLEAR });
export const clearCandidateDuplicates = () => ({ type: actions.CANDIDATE_DUPLICATES_CLEAR });
export const clearDeleteCandidates = () => ({ type: actions.CANDIDATE_DELETE_CLEAR });
export const clearPersonDelete = () => ({ type: actions.PERSON_DELETE_CLEAR });
export const clearPersonDeleteMerge = () => ({ type: actions.PERSON_DELETE_MERGE_CLEAR });
export const clearCandidateDeleteMerge = () => ({ type: actions.CANDIDATE_MERGE_DELETE_CLEAR });
export const clearAddAvailability = () => ({ type: actions.ADD_AVAILABILITY_CLEAR });
export const clearRemoveAvailability = () => ({ type: actions.REMOVE_AVAILABILITY_CLEAR });
export const clearDeleteTimeoff = () => ({ type: actions.DELETE_TIMEOFF_CLEAR });
export const clearConfirmTimeOff = () => ({ type: actions.CONFIRM_TIME_OFF_CLEAR });
export const clearUpdateBookingRates = () => ({ type: actions.UPDATE_BOOKING_PAY_RATES_CLEAR });
